import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import Icon from "./Icon";
import { NAV_LINKS, REGISTER_URL, SIGNIN_URL, CONTACT_EMAIL } from "./landingData";
import { DashboardLink } from "./DashboardOpenOverlay";

const LOGO_WHITE = "/images/claritick_tm_white.svg";

/**
 * Rendered fresh per page (via LandingShell), unlike LandingNav which stays mounted — a page
 * transition remounting the footer gives a visible "new page" cue while the persistent nav
 * still keeps the overall shell feeling like an SPA rather than a full reload.
 */
const LandingFooter = () => {
    const token = Cookies.get("access_token");
    const user = useSelector((state) => state.userReducer?.user);
    const location = useLocation();
    const isHome = location.pathname === "/";

    const scrollTo = (e, href) => {
        if (!href.startsWith("#")) return;
        e.preventDefault();
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const footerLink = (l) => {
        if (isHome && l.path === "/" && l.hash) {
            return (
                <a key={l.label} href={l.hash} onClick={(e) => scrollTo(e, l.hash)}>
                    {l.label}
                </a>
            );
        }
        if (l.hash) {
            return <Link key={l.label} to={`${l.path}${l.hash}`}>{l.label}</Link>;
        }
        return <Link key={l.label} to={l.path}>{l.label}</Link>;
    };

    return (
        <footer className="clk-footer">
            <div className="clk-container">
                <div className="clk-footer-top">
                    <div className="clk-footer-brand">
                        <img src={LOGO_WHITE} alt="Claritick" className="clk-footer-logo" />
                        <p>The simple, collaborative ticketing platform that helps teams capture, track and resolve customer requests with clarity.</p>
                        <div className="clk-footer-social">
                            <a href="https://www.facebook.com/Claritick-105524795322767" target="_blank" rel="noreferrer" aria-label="Facebook"><Icon name="facebook" size={18} /></a>
                            <a href="https://www.twitter.com/claritick" target="_blank" rel="noreferrer" aria-label="Twitter"><Icon name="twitter" size={18} /></a>
                            <a href="https://www.linkedin.com/company/claritick" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Icon name="linkedin" size={18} /></a>
                            <a href="https://www.youtube.com/channel/UCHuoIDHYD5KBNopxUFsZT2w" target="_blank" rel="noreferrer" aria-label="YouTube"><Icon name="youtube" size={18} /></a>
                        </div>
                    </div>
                    <div className="clk-footer-col">
                        <h5>Product</h5>
                        {NAV_LINKS.filter((l) => l.label !== "Contact").map(footerLink)}
                        <Link to="/blog">Blog</Link>
                    </div>
                    <div className="clk-footer-col">
                        <h5>Company</h5>
                        {footerLink({ label: "Contact", path: "/contact" })}
                        <a href="https://kore.co" target="_blank" rel="noreferrer">Kore.co</a>
                        <a href="https://kore.co/privacy" target="_blank" rel="noreferrer">Privacy</a>
                        <a href="https://kore.co/terms" target="_blank" rel="noreferrer">Terms</a>
                        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                    </div>
                    <div className="clk-footer-col">
                        <h5>Get started</h5>
                        {token ? (
                            <DashboardLink>Dashboard</DashboardLink>
                        ) : (
                            <>
                                <a href={SIGNIN_URL}>Sign in</a>
                                <a href={REGISTER_URL}>Create account</a>
                                <a href={REGISTER_URL}>Schedule a demo</a>
                            </>
                        )}
                    </div>
                </div>
                <div className="clk-footer-bottom">
                    <span>Claritick, a Kore.co company · © {new Date().getFullYear()} All rights reserved.</span>
                    <span>Frisco, TX · (888) 744-7388 · {CONTACT_EMAIL}</span>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
